import "../../../../design/termsAndConditions.css";
import { useState } from "react";
import { termsSections } from "../../../../utils/functions/termsData";
import Footer from "../Footer";
import { motion, AnimatePresence } from "framer-motion";

const TermsAndConditions = () => {
    const [open, setOpen] = useState(null);

    const getSectionId = (rawId) => parseInt(rawId);

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: { staggerChildren: 0.1 }
        }
    };

    const itemVariants = {
        hidden: { y: 20, opacity: 0 },
        visible: {
            y: 0,
            opacity: 1,
            transition: { type: "spring", stiffness: 100 }
        }
    };

    return (
        <>
            {/* Navbar Spacer - აგვარებს დაფარული კონტენტის პრობლემას */}
            <div className="navbar-spacer"></div>

            <div className="termsPage">
                {/* Background Decorative Blobs */}
                <div className="blob-container">
                    <motion.div
                        className="blob blob-1"
                        animate={{ x: [0, 40, 0], y: [0, 60, 0] }}
                        transition={{ duration: 15, repeat: Infinity, ease: "linear" }}
                    />
                    <motion.div
                        className="blob blob-2"
                        animate={{ x: [0, -50, 0], y: [0, 40, 0] }}
                        transition={{ duration: 20, repeat: Infinity, ease: "linear" }}
                    />
                </div>

                <motion.div
                    className="termsHeroNew"
                    initial="hidden"
                    animate="visible"
                    variants={containerVariants}
                >
                    <motion.div className="heroBadge" variants={itemVariants}>
                        <span>განახლებულია: 3 მარტი, 2026</span>
                    </motion.div>

                    <motion.h1 className="heroTitle" variants={itemVariants}>
                        ჩვენი პლატფორმის <span className="gradientText">წესები</span> და პირობები
                    </motion.h1>

                    <motion.p className="heroSubtitle" variants={itemVariants}>
                        იმისათვის, რომ ჩვენი სივრცე იყოს უსაფრთხო და სასიამოვნო ყველასთვის,
                        გთხოვთ, გაეცნოთ ძირითად პრინციპებს.
                    </motion.p>

                    <motion.div className="heroKeyPoints" variants={itemVariants}>
                        <div className="keyPointCard pt-teacher">
                            <span className="card-icon">👩‍🏫</span>
                            <h3>მასწავლებლებს</h3>
                            <p>შექმენით პროფილი და მშობლები თავად დაგიკავშირდებიან სერვისისთვის.</p>
                        </div>
                        <div className="keyPointCard pt-parent">
                            <span className="card-icon">👨‍👩‍👧</span>
                            <h3>მშობლებს</h3>
                            <p>იპოვეთ საუკეთესო რეპეტიტორები თქვენი შვილების ინტერესებიდან გამომდინარე.</p>
                        </div>
                        <div className="keyPointCard pt-all">
                            <span className="card-icon">🤝</span>
                            <h3>ყველას</h3>
                            <p>იყავით კეთილსინდისიერები, პატივი ეცით სხვის დროსა და შრომას.</p>
                        </div>
                    </motion.div>
                </motion.div>

                <div className="detailed-terms-header">
                    <h2>დეტალური წესები</h2>
                    <div className="header-underline"></div>
                </div>

                <div className="termsListWrapper">
                    {termsSections.map((section) => {
                        const sectionIdInt = getSectionId(section.id);
                        return (
                            <div key={section.id} className={`termsSection section-${sectionIdInt}`}>
                                <h2 className="termsSectionTitle">
                                    <span className="termsSectionIcon">{section.icon}</span>
                                    {section.title}
                                </h2>

                                {section.subsections.map((sub) => {
                                    const isOpen = open === sub.id;
                                    return (
                                        <div key={sub.id} className={`termsSubsection ${isOpen ? "open" : ""}`}>
                                            <button className="termsSubHeader" onClick={() => setOpen(isOpen ? null : sub.id)}>
                                                <span className="header-text-container">
                                                    <span className="termsNumber">{sub.id}</span>
                                                    {sub.title}
                                                </span>
                                                <span className="termsArrow">{isOpen ? "✕" : "+"}</span>
                                            </button>

                                            <AnimatePresence>
                                                {isOpen && (
                                                    <motion.div
                                                        className="termsContent"
                                                        initial={{ height: 0, opacity: 0 }}
                                                        animate={{ height: "auto", opacity: 1 }}
                                                        exit={{ height: 0, opacity: 0 }}
                                                        transition={{ duration: 0.3 }}
                                                    >
                                                        {sub.content.map((line, i) => {
                                                            const [sId, subId] = sub.id.split(".");
                                                            return (
                                                                <p key={i}>
                                                                    <strong>{sId}.{subId}.{i + 1}</strong> {line}
                                                                </p>
                                                            );
                                                        })}
                                                    </motion.div>
                                                )}
                                            </AnimatePresence>
                                        </div>
                                    );
                                })}
                            </div>
                        );
                    })}
                </div>
            </div>
            <Footer />
        </>
    );
};

export default TermsAndConditions;